import { Component, OnInit } from "@angular/core";
import {
  faPlus,
  faEdit,
  faTrash,
  faBroom,
  faEye,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CoeAllocationService } from "src/app/services/autopac/coe-allocation.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-coe-allocation",
  templateUrl: "./coe-allocation.component.html",
  styleUrls: ["./coe-allocation.component.css"],
})
export class CoeAllocationComponent implements OnInit {
  faPlus = faPlus;
  faEdit = faEdit;
  faTrash = faTrash;
  faBroom = faBroom;
  faEye = faEye;
  faUpload = faUpload;

  file!: ArrayBuffer;
  fileName: string = "";
  enableShow: boolean = false;
  enableDate: boolean = false;

  detailsContract: FormField[] = [
    {
      type: "search",
      id: "ContractNo",
      label: "Contract number",
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "ContractName",
      label: "Contract name",
    },
  ];
  detailsCOE: FormField[] = [
    {
      type: "search",
      id: "Nric",
      label: "Bidder's NRIC",
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "bidderName",
      label: "Bidder's name",
      required: true,
    },
    {
      type: "search",
      id: "CoeCertificateNo",
      label: "COE certificade No",
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "CoeAmount",
      label: "COE amount",
    },
    {
      type: "number",
      id: "CoeDepositAmount",
      label: "COE deposit amount",
      value: 10000,
    },
    {
      type: "date",
      id: "CoeBidDate",
      label: "COE Bid Date (dd/mm/yyyy)",
      value: new Date().toISOString().split("T")[0],
    },
    {
      type: "select",
      id: "CoeCategory",
      label: "COE category",
      options: [],
    },
    {
      type: "date",
      id: "CoeExipryDate",
      label: "COE expiry date (dd/mm/yyyy)",
    },
    {
      type: "date",
      id: "CoeTakenDate",
      label: "COE actual taken date",
    },
    {
      type: "text",
      id: "TakenBy",
      label: "Taken by",
    },
  ];
  uploadCOECertificates: FormField[] = [
    {
      type: "date",
      id: "coeBidDate",
      label: "Input COE bid date (dd/mm/yyyy)",
    },
  ];
  tableHeadersGvcust = [
    {
      title: "CONTRACT NO.",
      type: "data",
      id: "ContractNo",
    },
    {
      title: "BIDDER'S NAME",
      type: "data",
      id: "Name",
    },
    {
      title: "BID DATE",
      type: "data",
      id: "CoeBidDate",
    },
    {
      title: "BID AMOUNT",
      type: "data",
      id: "CoeAmount",
    },
    {
      title: "CATEGORY",
      type: "data",
      id: "CoeCategory",
    },
    {
      title: "COE CERTIFICATE NO.",
      type: "data",
      id: "CoeCertificateNo",
    },
    {
      title: "COE DEPOSIT AMOUNT",
      type: "data",
      id: "CoeDepositAmount",
    },
    {
      title: "",
      type: "save",
    },
  ];
  tableEntriesGvcust: any[] = [];
  tableHeadersGvcontract = [
    {
      title: "CONTRACT NO.",
      type: "data",
      id: "ContractNo",
    },
    {
      title: "BUYER'S NAME",
      type: "data",
      id: "Name",
    },
    {
      title: "SALES CONSULTANT",
      type: "data",
      id: "Salesman",
    },
    {
      title: "",
      type: "save",
    },
  ];
  tableEntriesGvcontract: any[] = [];
  legends = [
    {
      label: "Invalid Contract Number.",
      color: "bg-[#00ffff]",
      active: true,
    },
    {
      label: "Duplicated COE Certificates.",
      color: "bg-[#6495ed]",
      active: true,
    },
    {
      label: "Name didn't matched.",
      color: "bg-[#9acd32]",
      active: true,
    },
  ];
  tableHeadersCertificates = [
    {
      title: "S/NO.",
      type: "data",
      id: "Sno",
    },
    {
      title: "COE CATEGORY",
      type: "data",
      id: "CoeCategory",
    },
    {
      title: "BIDDER'S NAME",
      type: "data",
      id: "BidderName",
    },
    {
      title: "BIDDER'S NRIC",
      type: "data",
      id: "Nric",
    },
    {
      title: "COE AMOUNT",
      type: "data",
      id: "CoeAmount",
    },
    {
      title: "COE DEPOSIT AMOUNT",
      type: "data",
      id: "CoeDepositAmount",
    },
    {
      title: "BALANCE",
      type: "data",
      id: "Balance",
    },
    {
      title: "COE CERTIFICATE NO.",
      type: "data",
      id: "CoeCertificateNo",
    },
    {
      title: "COE EXPIRY DATE",
      type: "data",
      id: "CoeExpiryDate",
    },
    {
      title: "COE BID DATE",
      type: "data",
      id: "CoeBidDate",
    },
    {
      title: "CONTRACT NO.",
      type: "data",
      id: "ContractNo",
    },
  ];
  tableEntriesCertificates: any[] = [];
  selectedTab = "single";
  BidType: string = "C";
  RefNo: string | null = null;

  constructor(
    private coeAllocationService: CoeAllocationService,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {
    this.coeAllocationService.GetCategoryList().subscribe({
      next: (response) => {
        let CoeCategory = this.getField("CoeCategory", "detailsCOE");
        CoeCategory.options = response.body.map((item: any) => ({
          display: item,
          value: item,
        }));
        CoeCategory.value = "A";
        let CoeBidDate = this.getField(
          "CoeBidDate",
          "detailsCOE",
        ).value;
        CoeBidDate = `"${this.inputToDate(CoeBidDate)}"`;
        this.coeAllocationService
          .CheckCategory(CoeBidDate, CoeCategory.value)
          .subscribe({
            next: (response) =>
              (this.getField("CoeExipryDate", "detailsCOE").value =
                this.dateToInput(response.body)),
            error: console.error,
          });
      },
    });
  }

  searchContract(): void {
    const BidType = this.BidType;
    const BidDate = this.inputToDate(
      this.getField("CoeBidDate", "detailsCOE").value,
    );
    const CoeCategory = this.getField(
      "CoeCategory",
      "detailsCOE",
    ).value;
    const CoeDepositAmount = this.getField(
      "CoeDepositAmount",
      "detailsCOE",
    ).value;
    const CoeExipryDate = this.inputToDate(
      this.getField("CoeExipryDate", "detailsCOE").value,
    );
    const ContractNo = this.getField(
      "ContractNo",
      "detailsContract",
    ).value;
    this.coeAllocationService
      .OnContractChange(
        BidType,
        BidDate,
        CoeCategory,
        CoeDepositAmount,
        CoeExipryDate,
        ContractNo,
      )
      .subscribe({
        next: (response) =>
          this.handleReponse("contract", response.body),
        error: console.error,
      });
  }

  searchData(event: any): void {
    const BidType = this.BidType;
    const BidDate = this.inputToDate(
      this.getField("CoeBidDate", "detailsCOE").value,
    );
    const CoeCategory = this.getField(
      "CoeCategory",
      "detailsCOE",
    ).value;
    const CoeCertificateNo = this.getField(
      "CoeCertificateNo",
      "detailsCOE",
    ).value;
    const CoeDepositAmount = this.getField(
      "CoeDepositAmount",
      "detailsCOE",
    ).value;
    const CoeExipryDate = this.inputToDate(
      this.getField("CoeExipryDate", "detailsCOE").value,
    );
    const ContractName = this.getField(
      "ContractName",
      "detailsContract",
    ).value;
    const ContractNo = this.getField(
      "ContractNo",
      "detailsContract",
    ).value;
    const Nric = this.getField("Nric", "detailsCOE").value;
    if (event.fieldId == "Nric") {
      this.coeAllocationService
        .OnNricChange(
          BidType,
          BidDate,
          CoeCategory,
          CoeDepositAmount,
          CoeExipryDate,
          ContractName,
          ContractNo,
          Nric,
        )
        .subscribe({
          next: (response) =>
            this.handleReponse("nric", response.body),
          error: console.error,
        });
    } else {
      this.coeAllocationService
        .OnCertificateNoChange(
          BidType,
          BidDate,
          CoeCategory,
          CoeCertificateNo,
          CoeDepositAmount,
          CoeExipryDate,
          ContractName,
          ContractNo,
          Nric,
        )
        .subscribe({
          next: (response) =>
            this.handleReponse("coecertificateno", response.body),
        });
    }
  }

  private handleReponse(type: string, response: any): void {
    switch (type) {
      case "contract":
        if (response.code !== 0) {
          this.notifier.notify("error", response.Message);
        } else {
          this.getField("CoeBidDate", "detailsCOE").value =
            this.dateToInput(response.Data.CoeBidDate);
          this.BidType = this.dateToInput(response.Data.BidType);
          this.getField("CoeDepositAmount", "detailsCOE").value =
            this.dateToInput(response.Data.CoeDepositAmount);
          this.getField("CoeCategory", "detailsCOE").value =
            this.dateToInput(response.Data.CoeCategory);
          this.getField("CoeExipryDate", "detailsCOE").value =
            this.dateToInput(response.Data.CoeExipryDate);
          this.getField("ContractName", "detailsContract").value =
            this.dateToInput(response.Data.Name);
          this.getField("Nric", "detailsCOE").value =
            this.dateToInput(response.Data.Nric);
          this.getField("CoeCertificateNo", "detailsCOE").value =
            this.dateToInput(response.Data.CoeCertificateNo);
          this.getField("CoeAmount", "detailsCOE").value =
            this.dateToInput(response.Data.CoeAmount);
          this.getField("CoeTakenDate", "detailsCOE").value =
            this.dateToInput(response.Data.CoeTakenDate);
          this.getField("TakenBy", "detailsCOE").value =
            this.dateToInput(response.Data.TakenBy);
        }
        break;
      case "nric":
        if (response.code !== 0) {
          this.notifier.notify("error", response.Message);
        } else if (response.Data.GvCust.lenght() == 1) {
          this.getField("Nric", "detailsContract").value =
            this.dateToInput(response.Data.GvCust[0].Nric);
          this.getField("ContractName", "detailsContract").value =
            this.dateToInput(response.Data.GvCust[0].Name);
          this.getField("CoeDepositAmount", "detailsContract").value =
            this.dateToInput(
              response.Data.GvCust[0].CoeDepositAmount,
            );
          this.getField("CoeCertificateNo", "detailsCOE").value =
            this.dateToInput(
              response.Data.GvCust[0].CoeCertificateNo,
            );
          this.getField("CoeAmount", "detailsCOE").value =
            this.dateToInput(response.Data.GvCust[0].CoeAmount);
          this.getField("CoeTakenDate", "detailsCOE").value =
            this.dateToInput(response.Data.GvCust[0].CoeTakenDate);
          this.getField("TakenBy", "detailsCOE").value =
            this.dateToInput(response.Data.GvCust[0].TakenBy);
        } else {
          response.Data.GvCust.forEach((item: any) => {
            const newItem = {
              ContractNo: item.ContractNo,
              Name: item.Name,
              CoeBidDate: item.CoeBidDate,
              CoeAmount: item.CoeAmount,
              CoeCategory: item.CoeCategory,
              CoeCertificateNo: item.CoeCertificateNo,
              CoeDepositAmount: item.CoeDepositAmount,
              select: "",
            };
            this.tableEntriesGvcust.push(newItem);
          });
          response.Data.GvContract.forEach((item: any) => {
            const newItem = {
              ContractNo: item.ContractNo,
              Name: item.FirstName,
              Salesman: item.SalesmanCode,
              select: "",
            };
            this.tableEntriesGvcontract.push(newItem);
          });
        }
        break;
      case "coecertificateno":
        this.getField("CoeBidDate", "detailsCOE").value =
          this.dateToInput(response.Data.CoeBidDate);
        this.BidType = this.dateToInput(response.Data.BidType);
        this.getField("CoeDepositAmount", "detailsCOE").value =
          this.dateToInput(response.Data.CoeDepositAmount);
        this.getField("CoeCategory", "detailsCOE").value =
          this.dateToInput(response.Data.CoeCategory);
        this.getField("CoeExipryDate", "detailsCOE").value =
          this.dateToInput(response.Data.CoeExipryDate);
        this.getField("ContractNo", "detailsContract").value =
          this.dateToInput(response.Data.ContractNo);
        this.RefNo = this.dateToInput(response.Data.RefNo);
        this.getField("ContractName", "detailsContract").value =
          this.dateToInput(response.Data.Name);
        this.getField("Nric", "detailsCOE").value = this.dateToInput(
          response.Data.Nric,
        );
        this.getField("CoeCertificateNo", "detailsCOE").value =
          this.dateToInput(response.Data.CoeCertificateNo);
        this.getField("CoeAmount", "detailsCOE").value =
          this.dateToInput(response.Data.CoeAmount);
        this.getField("CoeTakenDate", "detailsCOE").value =
          this.dateToInput(response.Data.CoeTakenDate);
        this.getField("TakenBy", "detailsCOE").value =
          this.dateToInput(response.Data.TakenBy);
        break;
    }
  }

  addEntry(event: any, type: string): void {
    if (type == "Gvcust") {
      this.getField("ContractNo", "detailsContract").value =
        event.ContractNo;
      this.getField("ContractName", "detailsContract").value =
        event.Name;
      this.getField("BidderName", "detailsCOE").value = event.Name;
      this.getField("BidderName", "detailsCOE").value = event.Name;
    } else {
    }
  }

  updateFields(event: any): void {
    switch (event.name) {
      case "detailsContract":
        this.detailsContract = event.fields;
        break;
      case "detailsCOE":
        this.detailsCOE = event.fields;
        break;
      case "uploadCOECertificates":
        this.uploadCOECertificates = event.fields;
        if (
          this.getField("coeBidDate", "uploadCOECertificates").value
        ) {
          this.enableDate = true;
        }
        break;
    }
  }

  filterLegends(legends: any[]): any[] {
    return legends.filter((legend) => legend.active);
  }

  dateToInput(date: any): string {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
  }

  inputToDate(input: string): string {
    return input.split("-").reverse().join("/");
  }

  getField(id: string, form: string): FormField {
    const forms: { [key: string]: FormField[] } = {
      detailsContract: this.detailsContract,
      detailsCOE: this.detailsCOE,
      uploadCOECertificates: this.uploadCOECertificates,
    };
    const formData = forms[form] || [];
    return (
      formData.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  onFileChange(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;

    if (target.files.length !== 1) {
      console.error("Please, upload only one file");
      return;
    }

    const file = target.files[0];
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const arrayBuffer: ArrayBuffer = e.target.result;

      this.enableShow = true;
      this.fileName = file.name;
      this.file = arrayBuffer;
    };

    reader.readAsArrayBuffer(file);
  }

  showList(): void {
    this.tableEntriesCertificates = [];
    const date = this.getField(
      "coeBidDate",
      "uploadCOECertificates",
    ).value;
    const [year, month, day] = date.split("-");
    const newDate = `${day}/${month}/${year}`;

    /* this.coeAllocationService
      .UploadFiles(this.file, this.fileName, newDate)
      .subscribe({
        next: ({ body }) => {
          if (body.Code === 0) {
            body.Data.forEach((item: any) => {
              this.tableEntriesCertificates = [
                ...this.tableEntriesCertificates,
                item,
              ];
            });
          } else {
            console.log(body);
          }
        },
        error: console.error,
      }); */
  }

  clear(): void {
    this.tableEntriesCertificates = [];
  }
}
